import React from 'react';

import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const UserLogin = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Simple Logo Header */}
      <div className="border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center gap-3">
            <img 
              src="/assets/images/90A19BF4-3446-4543-87E4-2148054C81C1-1768952058269.jpeg" 
              alt="OfferSense Logo" 
              className="w-10 h-10 object-contain" 
            />
            <span className="text-xl header-logo-text">
              <span className="text-[#2C3E5F] font-bold">OfferSense</span>
              <span className="text-[#5DBFB3] font-bold">.Ai</span>
            </span>
          </div>
        </div>
      </div>

      <main className="main-content">
        <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-md">
            <div className="bg-card rounded-xl shadow-elevation-lg p-6 md:p-8 lg:p-10 border border-border">
              <LoginHeader />
              <LoginForm />
            </div>

            <div className="mt-8 md:mt-10 lg:mt-12">
              <SecurityBadges />
            </div>

            <div className="mt-6 md:mt-8 text-center">
              <p className="text-xs md:text-sm text-muted-foreground">
                By signing in, you agree to our Terms of Service and Privacy Policy
              </p>
            </div>
          </div>
        </div>
      </main>
      <footer className="border-t border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} OfferSense. All rights reserved.
            </p>
            <div className="flex items-center gap-4 md:gap-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Support
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default UserLogin;